import React from 'react';
import PropTypes from 'prop-types';

import NumberInputComponent from './components/numberInputComponent';

const EightYearGraduationRate = ({ onChange, initialValue }) => {
  const handleChange = (e, { value }) => {
    if (value.length > 3) {
      return;
    }
    onChange(e, { value });
  };

  return (
    <NumberInputComponent
      icon="percent"
      value={initialValue.value}
      onChange={handleChange}
      placeholder="100"
      name="Transfer-Eight-Year-Graduation-Rate"
    />
  );
};

EightYearGraduationRate.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
};
export default EightYearGraduationRate;
